import styled from 'styled-components';

interface IContainerProps {
  marginBottom?: string;
}

export const Container = styled.div<IContainerProps>`
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => props.marginBottom || '0px'};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #ddd;
  padding: 5px 10px;
  cursor: pointer;
`;

export const HeaderIndicator = styled.div`
  width: 20px;
  min-width: 20px;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #ddd;
  border-top: none;
  padding: 5px 10px;
`;

export const BodyContent = styled.div`
`;

export const BodyButtons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0px;
  border-top: 1px solid #ddd;
`;